import { useCallback, useEffect, useRef } from "react"

const useClickOutside = (callback, ids = []) => {
  const timeout = useRef()

  const handleClickOutside =
    useCallback((e) => {
      const elements = []

      ids.forEach(id => {
        elements.push(document.getElementById(id))
      })

      if (elements.length === 0) return

      if (elements.some(element => element.contains(e.target))) return

      callback()
    }, [])

  useEffect(() => {
    timeout.current =
      setTimeout(() => {
        window.addEventListener("click", handleClickOutside)
      }, 10)

    return () => {
      clearTimeout(timeout.current)

      window.removeEventListener("click", handleClickOutside)
    }
  }, [])
}

export default useClickOutside